import React, { useEffect } from 'react';
import { useAuth, useLoginWithRedirect } from '@frontegg/react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Login component — now powered by Frontegg embedded login.
 * 
 * Frontegg renders its own login UI in this component.
 * If the user is already authenticated, they're redirected to the main app.
 */
const AlchemiqLogin = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const loginWithRedirect = useLoginWithRedirect();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If already authenticated, redirect to the app
    if (!isLoading && isAuthenticated) {
      const redirectTo = searchParams.get('redirectTo') || '/';
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, searchParams]);

  useEffect(() => {
    // Trigger Frontegg login if not authenticated and not loading
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F5F5F5',
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#D4631C', fontSize: '22px', fontWeight: '600' }}>
            Alchemiq AI
          </h1>
          <p style={{ color: '#555', marginTop: '16px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  // Frontegg handles the login UI via loginWithRedirect
  // This fallback shows briefly while redirect happens
  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F5F5F5',
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ color: '#D4631C', fontSize: '22px', fontWeight: '600' }}>
          Alchemiq AI
        </h1>
        <p style={{ color: '#555', marginTop: '16px' }}>Redirecting to login...</p>
      </div>
    </div>
  );
};

export default AlchemiqLogin;
